import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBrx: CultureInfo = {
  name: 'brx',
  displayName: 'बरʼ',
  iso3LanguageCode: 'brx',
  iso2LanguageCode: 'brx',
  ietfLanguageTag: 'brx',
  parent: null
};
